(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('KeywordController', KeywordController);

    KeywordController.$inject = ['$scope', '$state', 'Keyword', 'KeywordCustomService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function KeywordController ($scope, $state, Keyword, KeywordCustomService, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            Keyword.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.keywords = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery || searchQuery.length === 0){
                vm.clear();
            }
            vm.currentSearch = searchQuery;
            KeywordCustomService.returnSearchKeywords(vm.currentSearch).then( function( data ) {
                vm.keywords = data.data;
                vm.totalItems = vm.keywords.length;
                vm.queryCount = vm.totalItems;
                vm.page = 1;
            }, function( error ) {
                vm.keywords = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.page = 1;
            });
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.loadAll()
        }
    }
})();
